import Cookie from 'cookie-universal'

import { CART_EMAIL } from '@mc/constants'

export const getCartEmailCookie = () => {
  const cookies = Cookie()

  return cookies.get(CART_EMAIL)?.replace(/['"]+/g, '') || ''
}
